import type { GameSettings } from '@/types/settings';
import { DEFAULT_SETTINGS } from '@/types/settings';

const STORAGE_KEY = 'packman_settings';

function readSettings(): GameSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return DEFAULT_SETTINGS;
    }
    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null) {
      return DEFAULT_SETTINGS;
    }
    const obj = parsed as Record<string, unknown>;
    const volume = typeof obj['volume'] === 'number' ? obj['volume'] : DEFAULT_SETTINGS.volume;
    return { volume: Math.max(0, Math.min(1, volume)) };
  } catch {
    return DEFAULT_SETTINGS;
  }
}

function writeSettings(settings: GameSettings): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
}

export function getVolume(): number {
  return readSettings().volume;
}

export function setVolume(level: number): void {
  const clamped = Math.max(0, Math.min(1, level));
  const current = readSettings();
  writeSettings({ ...current, volume: clamped });
}
